module.exports = __webpack_public_path__ + "img/swiper_02.362993ea.jpg";